import clsx from 'clsx';
import { Field, useField } from 'formik';
import React from 'react';

const CheckBoxField = (props) => {
  const { label, name, negativeFillClass, size, className } = props;
  const [field, meta, helpers] = useField(name);

  const handleKeyDown = (evt) => {
    // if user users tab to navigate to checkbox, and then hits
    // space bar (key code #32), that should toggle checkbox field
    if (evt.keyCode === 32) {
      evt.preventDefault();
      helpers.setValue(!field.value);
    }
  };

  return (
    <div className={clsx(`CheckBoxField form-group`, className)}>
      <div
        className={meta.touched && meta.error ? 'is-invalid' : ''}
        tabIndex="0"
        onKeyDown={handleKeyDown}
      >
        <label>
          <div className={`checkbox-container ${size === 'large' ? '--large' : ''}`}>
            <Field
              type="checkbox"
              className="checkbox-input"
              id={name}
              checked={field.value}
              name={name}
              {...field}
              {...props}
              onChange={() => helpers.setValue(!field.value)}
            />
            <div className={`checkbox-fill ${negativeFillClass ? 'fill-minus' : ''}`} />
            <span className="checkbox-text">{label}</span>
          </div>
        </label>
      </div>
      {meta.touched && meta.error && <div className="invalid-feedback">{meta.error}</div>}
    </div>
  );
};

export default CheckBoxField;
